exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".personal-status .image-container{height:10pc;width:10pc;background-color:#efefef;margin:0 auto;position:relative}.personal-status .image-container img{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}.personal-status .content-form{position:relative}.personal-status .content-form input{margin-top:10px;padding-right:20px}.personal-status .content-form i{position:absolute;top:50%;margin-top:-8px;right:5px}.personal-status .uploader-btn{text-align:center;cursor:pointer;margin-top:10px,}.personal-status__picture{height:150px;width:150px;top:5px;left:5px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/containers/App/screens/Foundation/screens/MyData/components/PersonalStatus/style.css
 ** module id = 1441
 ** module chunks = 10
 **/